@if (form.view) {
<form #formRef="ngForm" (ngSubmit)="submit()" @fadeInOut>
    <div class="followup-sections">
        <section class="followup-section">
            <h4 class="section-heading">NPY Decision</h4>
            <sf-form
                name="company"
                [view]="form.view"
                (ngModelChange)="onModelChanged($event)"
                [(ngModel)]="form.model"
                [fields]="['companyDecision', 'companyDecisionDate', 'companyDeclineReason']"
            ></sf-form>
        </section>

        <section class="followup-section">
            <h4 class="section-heading">Client Decision</h4>
            <sf-form
                name="client"
                [view]="form.view"
                (ngModelChange)="onModelChanged($event)"
                [(ngModel)]="form.model"
                [fields]="['clientDecision', 'clientDecisionDate', 'clientDeclineReason']"
            ></sf-form>
        </section>

        <section class="followup-section">
            <h4 class="section-heading">Outcome</h4>
            <sf-form
                name="outcome"
                [view]="form.view"
                (ngModelChange)="onModelChanged($event)"
                [(ngModel)]="form.model"
                [fields]="['outcomeStatus', 'placementStartDate', 'placementLocation', 'followUpNotes']"
            ></sf-form>
        </section>
    </div>

    @if (!options.hide_actions) {
    <ngxh6-form-actions
        [form]="form"
        [options]="options"
        [formRef]="formRef"
        [valid]="formRef.valid || false"
        (cancel)="cancel()"
        (delete)="delete()"
    ></ngxh6-form-actions>
    }
</form>
} @else { @if (form.error) {
<ngxh6-api-error [error]="form.error"></ngxh6-api-error>
} @else {
<ngxh6-loading-spinner @fadeInOut></ngxh6-loading-spinner>
} }
